import { INavParams } from 'pared/Routes/navParams'
import { LargeScreen, SmallScreen } from 'pared/components/responsive'
import { IDateRange } from 'pared/data/getDateRanges'
import { IDirector } from 'pared/data/getDirectors'

import WebLargeMain from './WebLargeMain'
import WebSmallMain from './WebSmallMain'
import { IGlobalGuestKpi, IGlobalGuestOpentableKpi } from './index'

interface IProps {
  navParams: INavParams
  allDirectors: IDirector[]
  selectedDirector: IDirector | null
  onDirectorChange: (directorEmployeeId: number) => Promise<void>
  selectedDateRange: IDateRange | null
  globalGuestKpiSummary: IGlobalGuestKpi
  selectedLocationGroupId: number
  breakdownType: string | null
  globalGuestOpentableKpis: IGlobalGuestOpentableKpi
}

function Main({
  navParams,
  allDirectors,
  selectedDirector,
  onDirectorChange,
  selectedDateRange,
  globalGuestKpiSummary,
  selectedLocationGroupId,
  breakdownType,
  globalGuestOpentableKpis,
}: IProps) {
  return (
    <>
      <LargeScreen>
        <WebLargeMain
          navParams={navParams}
          globalGuestKpiSummary={globalGuestKpiSummary}
          allDirectors={allDirectors}
          selectedDirector={selectedDirector}
          selectedDateRange={selectedDateRange}
          onDirectorChange={onDirectorChange}
          selectedLocationGroupId={selectedLocationGroupId}
          breakdownType={breakdownType}
          globalGuestOpentableKpis={globalGuestOpentableKpis}
        />
      </LargeScreen>
      <SmallScreen>
        <WebSmallMain
          navParams={navParams}
          globalGuestKpiSummary={globalGuestKpiSummary}
          allDirectors={allDirectors}
          selectedDirector={selectedDirector}
          selectedDateRange={selectedDateRange}
          onDirectorChange={onDirectorChange}
          selectedLocationGroupId={selectedLocationGroupId}
          breakdownType={breakdownType}
          globalGuestOpentableKpis={globalGuestOpentableKpis}
        />
      </SmallScreen>
    </>
  )
}

export default Main
